var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04289 17.2071C3.43342 17.5976 4.06658 17.5976 4.45711 17.2071L12.25 9.41421L20.0429 17.2071C20.4334 17.5976 21.0666 17.5976 21.4571 17.2071C21.8476 16.8166 21.8476 16.1834 21.4571 15.7929L12.9571 7.29289C12.5666 6.90237 11.9334 6.90237 11.5429 7.29289L3.04289 15.7929C2.65237 16.1834 2.65237 16.8166 3.04289 17.2071Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.cc0c4f3091b7fa2e46d08fe8dc470fb0.svg";
export { ForwardRef as ReactComponent };